var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8182 0H1.54545C0.695455 0 0 0.695455 0 1.54545V12.3636H1.54545V1.54545H10.8182V0ZM13.1364 3.09091H4.63636C3.78636 3.09091 3.09091 3.78636 3.09091 4.63636V15.4545C3.09091 16.3045 3.78636 17 4.63636 17H13.1364C13.9864 17 14.6818 16.3045 14.6818 15.4545V4.63636C14.6818 3.78636 13.9864 3.09091 13.1364 3.09091ZM13.1364 15.4545H4.63636V4.63636H13.1364V15.4545Z",
    fill: "#3397F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.1403282a590e490e0aae3a8c30048380.svg";
export { ForwardRef as ReactComponent };